/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import ReactOnRails from 'react-on-rails/client'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true) // eslint-disable-line unused-imports/no-unused-vars

import AnnouncementsApp from 'bundles/Announcements/startup/AnnouncementsApp'
import ColophonApp from 'bundles/Colophon/startup/ColophonApp'
import ErrorsApp from 'bundles/Errors/startup/ErrorsApp'
import CoinPurchaseApp from 'bundles/ExternalPayment/CoinPurchase/startup/CoinPurchaseApp'
import PaymentErrorApp from 'bundles/ExternalPayment/CoinPurchase/startup/PaymentErrorApp'
import PurchaseCompleteApp from 'bundles/ExternalPayment/CoinPurchase/startup/PurchaseCompleteApp'
import ExternalLoginApp from 'bundles/ExternalPayment/Login/startup/LoginApp'
import InquiryApp from 'bundles/Inquiry/startup/InquiryApp'
import StaticPageApp from 'bundles/StaticPage/startup/StaticPageApp'
import StoreBookDetailApp from 'bundles/Store/BookDetail/startup/StoreBookDetailApp'
import BulkPurchaseTitlesApp from 'bundles/Store/BulkPurchaseTitles/startup/BulkPurchaseTitlesApp'
import CartApp from 'bundles/Store/Cart/startup/CartApp'
import StoreFeatureListApp from 'bundles/Store/FeatureList/startup/StoreFeatureListApp'
import FreeFeatureApp from 'bundles/Store/FreeFeature/startup/FreeFeatureApp'
import HomeApp from 'bundles/Store/Home/startup/HomeApp'
import NewBooksApp from 'bundles/Store/NewBooks/startup/NewBooksApp'
import BookPurchaseApp from 'bundles/Store/Purchase/startup/BookPurchaseApp'
import BookPurchaseCompleteApp from 'bundles/Store/PurchaseComplete/startup/BookPurchaseCompleteApp'
import BookPurchaseErrorApp from 'bundles/Store/PurchaseError/startup/BookPurchaseErrorApp'
import RankingApp from 'bundles/Store/Ranking/startup/RankingApp'
import SearchFreeApp from 'bundles/Store/SearchFree/startup/SearchFreeApp'
import StoreSearchListApp from 'bundles/Store/SearchList/startup/StoreSearchListApp'
import AccountApp from 'bundles/User/Account/startup/AccountApp'
import BookPurchaseHistoryListApp from 'bundles/User/BookPurchaseHistoryList/startup/BookPurchaseHistoryListApp'
import BookshelfApp from 'bundles/User/Bookshelf/startup/BookshelfApp'
import CoinHistoriesApp from 'bundles/User/CoinHistories/startup/CoinHistoriesApp'
import CouponsApp from 'bundles/User/Coupons/startup/CouponsApp'
import LoginApp from 'bundles/User/Login/startup/LoginApp'
import MonthlyCourseHistoriesApp from 'bundles/User/MonthlyCourseHistories/startup/MonthlyCourseHistoriesApp'
import MonthlyCourseUnregisterApp from 'bundles/User/MonthlyCourseUnregister/startup/MonthlyCourseUnregisterApp'
import MonthlyCourseUnregisterCompleteApp from 'bundles/User/MonthlyCourseUnregister/startup/MonthlyCourseUnregisterCompleteApp'
import RestoreApp from 'bundles/User/Payment/startup/MonthlyCourse/RestoreApp'
import PaymentApp from 'bundles/User/Payment/startup/PaymentApp'
import PointHistoriesApp from 'bundles/User/PointHistories/startup/PointHistoriesApp'

// NOTE: react_on_rails gem は react_component ヘルパーに渡されたコンポーネント名を
// Ruby の camelize で変換する（例: "Store/Home/startup/HomeApp" → "Store::Home::Startup::Homeapp"）
// そのため、登録キーは camelize 後の名前に合わせる必要がある
ReactOnRails.register({
  'Announcements::Startup::Announcementsapp': AnnouncementsApp,
  'Colophon::Startup::Colophonapp': ColophonApp,
  'Errors::Startup::Errorsapp': ErrorsApp,
  'ExternalPayment::Coinpurchase::Startup::Coinpurchaseapp': CoinPurchaseApp,
  'ExternalPayment::Coinpurchase::Startup::Paymenterrorapp': PaymentErrorApp,
  'ExternalPayment::Coinpurchase::Startup::Purchasecompleteapp': PurchaseCompleteApp,
  'ExternalPayment::Login::Startup::Loginapp': ExternalLoginApp,
  'Inquiry::Startup::Inquiryapp': InquiryApp,
  'StaticPage::Startup::Staticpageapp': StaticPageApp,
  'Store::Bookdetail::Startup::Storebookdetailapp': StoreBookDetailApp,
  'Store::Bulkpurchasetitles::Startup::Bulkpurchasetitlesapp': BulkPurchaseTitlesApp,
  'Store::Cart::Startup::Cartapp': CartApp,
  'Store::Featurelist::Startup::Storefeaturelistapp': StoreFeatureListApp,
  'Store::Freefeature::Startup::Freefeatureapp': FreeFeatureApp,
  'Store::Home::Startup::Homeapp': HomeApp,
  'Store::Newbooks::Startup::Newbooksapp': NewBooksApp,
  'Store::Purchase::Startup::Bookpurchaseapp': BookPurchaseApp,
  'Store::Purchasecomplete::Startup::Bookpurchasecompleteapp': BookPurchaseCompleteApp,
  'Store::Purchaseerror::Startup::Bookpurchaseerrorapp': BookPurchaseErrorApp,
  'Store::Ranking::Startup::Rankingapp': RankingApp,
  'Store::Searchfree::Startup::Searchfreeapp': SearchFreeApp,
  'Store::Searchlist::Startup::Storesearchlistapp': StoreSearchListApp,
  'User::Account::Startup::Accountapp': AccountApp,
  'User::Bookpurchasehistorylist::Startup::Bookpurchasehistorylistapp': BookPurchaseHistoryListApp,
  'User::Bookshelf::Startup::Bookshelfapp': BookshelfApp,
  'User::Coinhistories::Startup::Coinhistoriesapp': CoinHistoriesApp,
  'User::Coupons::Startup::Couponsapp': CouponsApp,
  'User::Login::Startup::Loginapp': LoginApp,
  'User::Monthlycoursehistories::Startup::Monthlycoursehistoriesapp': MonthlyCourseHistoriesApp,
  'User::Monthlycourseunregister::Startup::Monthlycourseunregisterapp': MonthlyCourseUnregisterApp,
  'User::Monthlycourseunregister::Startup::Monthlycourseunregistercompleteapp': MonthlyCourseUnregisterCompleteApp,
  'User::Payment::Startup::Monthlycourse::Restoreapp': RestoreApp,
  'User::Payment::Startup::Paymentapp': PaymentApp,
  'User::Pointhistories::Startup::Pointhistoriesapp': PointHistoriesApp,
})
